import * as type from "../types";

export function getProductionDataRequested(organizationId) {
  return {
    type: type.GET_PRODUCTION_DATA_REQUESTED,
    payload: organizationId,
  };
}
export function getProductionDataSucceeded(data) {
  return {
    type: type.GET_PRODUCTION_DATA_SUCCEEDED,
    payload: data,
  };
}
export function getProductionDataFailed() {
  return {
    type: type.GET_PRODUCTION_DATA_FAILED,
  };
}
